import React from "react"

import FoundingStory from "../assets/Images/FoundingStory.png"
import BannerImage1 from "../assets/Images/aboutus1.webp"
import BannerImage2 from "../assets/Images/aboutus2.webp"
import BannerImage3 from "../assets/Images/aboutus3.webp"
import Footer from "../components/Common/Footer"
import ReviewSlider from "../components/Common/ReviewSlider"
import ContactFormSection from "../components/core/AboutPage/ContactFormSection"
import LearningGrid from "../components/core/AboutPage/LearningGrid"
import Quote from "../components/core/AboutPage/Quote"
import StatsComponenet from "../components/core/AboutPage/Stats"
import HighlightText from "../components/core/HomePage/HighlightText"

const About = () => {
  return (
    <div>
      <section className="bg-richblack-700">
        <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-center text-white">
          <header className="mx-auto py-20 text-4xl font-semibold lg:w-[70%]">
            Real Junior is transforming education by introducing
            <HighlightText text={"school students"} />
            <p className="mx-auto mt-3 text-center text-base font-medium text-richblack-300 lg:w-[95%]">
              to the world of technology in a fun and engaging way. By making coding and problem-solving accessible from an early age, it nurtures creativity and prepares young minds for a future driven by innovation.
            </p>
          </header>
          <div className="sm:h-[70px] lg:h-[150px]"></div>
          <div className="absolute bottom-0 left-[50%] grid w-[100%] translate-x-[-50%] translate-y-[30%] grid-cols-3 gap-3 lg:gap-5">
            <img src={BannerImage1} alt="" />
            <img src={BannerImage2} alt="" />
            <img src={BannerImage3} alt="" />
          </div>
        </div>
      </section>

      <section className="border-b border-richblack-700">
        <div className="mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-richblack-500">
          <div className="h-[100px] "></div>
          <Quote />
        </div>
      </section>

      <section>
        <div className="mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-richblack-500">
          <div className="flex flex-col items-center gap-10 lg:flex-row justify-between">
            <div className="my-24 flex lg:w-[50%] flex-col gap-10">
              <h1 className="bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#FCB045] bg-clip-text text-4xl font-semibold text-transparent lg:w-[70%] ">
                Our Founding Story
              </h1>
              <p className="text-base font-medium text-richblack-300 lg:w-[95%]">
                When I was in school, I had countless ideas, but I lacked the exposure to bring them to life. I had no idea what coding was or how technology could turn imagination into reality. It was only after entering engineering that I realized what I could have achieved if I had started earlier. This made me see a gap in our education system—students miss out on crucial skills simply because they are introduced too late.
              </p>
              <p className="text-base font-medium text-richblack-300 lg:w-[95%]">
                As we grow, distractions increase, and our ability to focus diminishes. The early years, when curiosity and learning potential are at their peak, are the best time to build a strong foundation. Real Junior was born to bridge this gap, ensuring that young minds get the right start at the right time.
              </p>
            </div>

            <div>
              <img
                src={FoundingStory}
                alt=""
                className="shadow-[0_0_20px_0] shadow-[#FC6767]"
              />
            </div>
          </div>
          <div className="flex flex-col items-center lg:gap-10 lg:flex-row justify-between">
            <div className="my-24 flex lg:w-[40%] flex-col gap-10">
              <h1 className="bg-gradient-to-b from-[#FF512F] to-[#F09819] bg-clip-text text-4xl font-semibold text-transparent lg:w-[70%] ">
                Our Vision
              </h1>
              <p className="text-base font-medium text-richblack-300 lg:w-[95%]">
                Our vision is to empower young minds by making technology and coding an integral part of early education. We aim to nurture creativity, problem-solving, and innovation from a young age, ensuring students have the skills to shape the future. By providing the right exposure at the right time, we strive to create a generation that doesn’t just use technology but builds it.
              </p>
            </div>
            <div className="my-24 flex lg:w-[40%] flex-col gap-10 -mt-16 sm:mt-0">
              <h1 className="bg-gradient-to-b from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text text-4xl font-semibold lg:w-[70%] ">
              Our Mission
              </h1>
              <p className="text-base font-medium text-richblack-300 lg:w-[95%]">
                Our mission is to make tech education accessible, engaging, and practical for students from class 5th to 9th. We strive to equip young learners with essential coding and problem-solving skills through interactive learning experiences. By fostering curiosity and innovation early, we aim to build a strong foundation that prepares them for the future.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <StatsComponenet /> */}
      <section className="mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-white sm:mt-20">
        {/* <LearningGrid /> */}
        <ContactFormSection /> 
      </section>

      <div className="relative mx-auto my-20 flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 bg-richblack-900 text-white">

        {/* This will be done a little later */}
        {/* Reviws from Other Learner */}
        <h1 className="text-center text-4xl font-semibold mt-8">
          {/* Reviews from other learners */}
        </h1>
        {/* <ReviewSlider /> */}
      </div>
      <Footer />
    </div>
  )
}

export default About
